import { PWAInstall } from './PWAInstall';
import "./PWAInstall.scss";

export function PWAInstallWrapper() {
  return (
    <div className="pwa-install__wrapper">
      <PWAInstall />
    </div>
  );
} 
